import API from '../api';

export const getPublicRegionalSettings = () =>
  API.get('/public/regional-settings').then((r) => r.data);

export const getAdminRegionalSettings = () =>
  API.get('/admin/regional-settings').then((r) => r.data);

export const saveAdminRegionalSettings = (payload) =>
  API.put('/admin/regional-settings', payload).then((r) => r.data);

/** Full snapshot from Setup Wizard — writes to regional_settings singleton. */
export const saveOnboardingRegionalSettings = (payload) =>
  API.post('/admin/regional-settings/onboarding', payload).then((r) => r.data);
